export const baseFont = '"Source Sans Pro", sans-serif'
export const oswald = '"Oswald", sans-serif'
